export default __webpack_public_path__ + "static/media/fridge.8e960549.svg";